import { render, staticRenderFns } from "./story_row.vue?vue&type=template&id=315e9c33&scoped=true&lang=pug"
import script from "./story_row.vue?vue&type=script&lang=js"
export * from "./story_row.vue?vue&type=script&lang=js"
import style0 from "./story_row.vue?vue&type=style&index=0&id=315e9c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e9c33",
  null
  
)

export default component.exports